import { author, homepage, license } from '../package.json'

export const AUTHOR = author
export const HOMEPAGE = homepage
export const AUTHOR_GITHUB_URL = `https://github.com/${AUTHOR}`
export const LICENSE = license
export const LICENSE_URL = `${homepage}/blob/master/LICENSE`
